export const data1 = [
  "/images/media/486083457_1074216361401368_7515847816156332332_n.jpg",
  "/images/media/489910053_1074216464734691_5649577845029135813_n.jpg",
  "/images/media/490018312_1074215954734742_1131415510209277031_n.jpg",
  "/images/media/486448231_1074216638068007_7154308972937587476_n.jpg",
  "/images/media/487355701_1074216551401349_2829037790954484107_n.jpg",
  "/images/media/487384188_1074216244734713_3463673495892343670_n.jpg",
];
 